import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccountComponent } from './account.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PermissionGuard } from '../core/guards/permission/permission.guard';
import { LandingModule } from '../landing/landing.module';
import { CoreModule } from '../core/core.module';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { FourOhFourComponent } from './four-oh-four/four-oh-four.component';
import { ServerErrorComponent } from './server-error/server-error.component';
import { ConfirmActionModalComponent } from './view-order/confirm-action-modal/confirm-action-modal.component';
import { GraphQLModule } from '@app/graphql/graphql.module';
import { AccountRoutingModule } from './account-routing.module';
import { AdditionalFieldsMismatchModalComponent } from './new-order-v2/additional-fields-mismatch-modal/additional-fields-mismatch-modal.component';
import { CardService } from './dashboard/card.service';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { GlobalLayoutModule } from '@app/shared/global-layout/global-layout.module';
import { DiscardConfirmationModalComponent } from '@app/shared/discard-confirmation-modal/discard-confirmation-modal.component';
import { NotificationsAndAlertsComponent } from './notifications-and-alerts/notifications-and-alerts.component';

@NgModule({
  declarations: [
    AccountComponent,
    AdditionalFieldsMismatchModalComponent,
    FourOhFourComponent,
    ServerErrorComponent,
    ConfirmActionModalComponent,
    NotificationsAndAlertsComponent,
    DiscardConfirmationModalComponent,
  ],
  imports: [
    CoreModule,
    CommonModule,
    GraphQLModule,
    AccountRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    LandingModule,
    DropzoneModule,
    GlobalLayoutModule,
  ],
  exports: [RouterModule],
  providers: [PermissionGuard, CardService, DatePipe, TitleCasePipe],
})
export class AccountModule {}
